export const RESET = 'RESET';
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';
export const SWITCH_FLOOR = 'SWITCH_FLOOR';
export const SELECT_SHOP = 'SELECT_SHOP';
export const CLEAR_SHOP = 'CLEAR_SHOP';
export const TOGGLE_SHOP = 'TOGGLE_SHOP';
export const SELECT_CAT = 'SELECT_CAT';
export const CLEAR_CAT = 'CLEAR_CAT';
export const TOGGLE_CAT = 'TOGGLE_CAT';
export const OPEN_SEARCH = 'OPEN_SEARCH';
export const CLOSE_SEARCH = 'CLOSE_SEARCH';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const START_IDLING ='START_IDLING';
export const END_IDLING ='END_IDLING';
export const SHOW_RESTROOMS ='SHOW_RESTROOMS';
export const HIDE_RESTROOMS ='HIDE_RESTROOMS';
export const TOGGLE_RESTROOMS ='TOGGLE_RESTROOMS';
export const SHOW_SHOP_MODAL ='SHOW_SHOP_MODAL';
export const HIDE_SHOP_MODAL ='HIDE_SHOP_MODAL';
export const SHOW_OFFERS_MODAL ='SHOW_OFFERS_MODAL';
export const HIDE_OFFERS_MODAL ='HIDE_OFFERS_MODAL';
export const CHANGE_MODAL_OFFER ='CHANGE_MODAL_OFFER';
export const ENABLE_AUTO_SCROLL_TO_CURRENT ='ENABLE_AUTO_SCROLL_TO_CURRENT';
export const DISABLE_AUTO_SCROLL_TO_CURRENT ='DISABLE_AUTO_SCROLL_TO_CURRENT';
export const UPDATE_PATH_FINDER_TARGET_SHOP ='UPDATE_PATH_FINDER_TARGET_SHOP';
